export default {
  state: {
    bundleList: [],
    site: ''
  },
  mutations: {
    setBundleList(state, data) {
      state.bundleList = data;
    },
    setSite(state, data) {
      state.site = data;
    }
  },
  actions: {}
};
